import { useEffect, useState } from 'react';
import { Capacitor } from '@capacitor/core';
import { PushNotifications } from '@capacitor/push-notifications';
import { useAuth } from '../context/AuthContext';

const PERMISSIONS_REQUESTED_KEY = 'native_permissions_requested';

/**
 * Hook para solicitar permisos nativos al instalar la app
 * Solo se ejecuta una vez en plataformas nativas (Android/iOS)
 */
export const useNativePermissions = () => {
  const { user } = useAuth();
  const [shouldShowModal, setShouldShowModal] = useState(false);
  const isNative = Capacitor.isNativePlatform();

  useEffect(() => {
    // Solo ejecutar en plataformas nativas y si hay usuario
    if (!isNative || !user) return;

    const checkAndRequestPermissions = async () => {
      // Verificar si ya se solicitaron permisos antes
      const permissionsRequested = localStorage.getItem(PERMISSIONS_REQUESTED_KEY);
      
      if (permissionsRequested === 'true') {
        return; // Ya se solicitaron anteriormente
      }

      try {
        // Verificar el estado actual de los permisos
        const permStatus = await PushNotifications.checkPermissions();
        
        // Si los permisos son 'prompt' (nunca preguntado), mostrar el modal
        if (permStatus.receive === 'prompt') {
          setShouldShowModal(true);
        } else {
          // Si ya están concedidos o denegados, marcar como solicitado
          localStorage.setItem(PERMISSIONS_REQUESTED_KEY, 'true');
        }
      } catch (error) {
        console.error('Error checking native permissions:', error);
      }
    };

    // Ejecutar después de un pequeño delay para que la UI cargue primero
    const timer = setTimeout(checkAndRequestPermissions, 2000);

    return () => clearTimeout(timer);
  }, [isNative, user]);

  const markAsRequested = () => {
    localStorage.setItem(PERMISSIONS_REQUESTED_KEY, 'true');
    setShouldShowModal(false);
  };

  return {
    shouldShowModal,
    markAsRequested,
    isNative,
  };
};
